# Controls for the scrollable containers holding individual job (not app) workflows. 

;(( $, window, document )->
  pluginName = "cpScrollButtons"
  defaults = {
    scrollableSelector: '.scrollable'
    leftSelector: '.scroll-left'
    rightSelector: '.scroll-right'
    columnSelector: '.scroll-step'
  }

  cpScrollButtons = ( element, options )->
    @element = $(element)
    @options = $.extend( {}, defaults, options)
    @_defaults = defaults
    @_name = pluginName
    @init()

  cpScrollButtons.prototype = {
    init: ->
      @scrollableElement = @element.find(@options.scrollableSelector)
      @leftButton = @element.find(@options.leftSelector)
      @rightButton = @element.find(@options.rightSelector)

      @enableButtons()
      @element.on 'mouseenter', =>
        @element.addClass('hovered')
      @element.on 'mouseleave', =>
        @element.removeClass('hovered')

      @leftButton.on 'click', (ev)=>
        ev.preventDefault()
        @leftClick()
      @rightButton.on 'click', (ev)=>
        ev.preventDefault()
        @rightClick()
    ,

    enableButtons: ->
      leftmost = @element.width() - @scrollableElement.width()
      pos = @scrollableElement.position()
      return if pos == undefined
      if pos.left < 0
        @leftButton.fadeIn('fast')
      else
        @leftButton.fadeOut('fast')
      if pos.left < leftmost
        @rightButton.fadeOut('fast')
      else
        @rightButton.fadeIn('fast')
    ,

    moveSteps: (pos)->
      @scrollableElement.animate {
        left: @scrollableElement.position().left - pos
      },
        'fast',
        null,
        =>
          @enableButtons()
    ,

    leftClick: ->
      cntl = @element.offset().left
      last_step = null
      @scrollableElement.find(@options.columnSelector).each ->
        stepl = $(this).offset().left - cntl
        if stepl < 0
          last_step = [$(this), stepl]
      if last_step != null
        @moveSteps(last_step[1])
    ,

    rightClick: ->
      cntl = @element.offset().left
      next_step = null
      left_side = parseInt(@element.css('padding-left').replace('px',''))
      @scrollableElement.find(@options.columnSelector).each ->
        stepl = $(this).offset().left - cntl
        if next_step == null && stepl > left_side
          next_step = [$(this), stepl]
      if next_step != null
        @moveSteps(next_step[1])
  }

  $.fn[pluginName] = ( options )->
    this.each ->
      if !$.data(@, "plugin_" + pluginName)
        $.data @, "plugin_" + pluginName, new cpScrollButtons(@, options)

)( jQuery, window, document )

$(->
  $('.has-scroll-buttons').cpScrollButtons()
)
